import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';

import { SkyDefinitionListService } from './definition-list.service';


export class SkyDefinitionListLabelComponent {
  public labelWidth: number;

  constructor(
    public service: SkyDefinitionListService) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list-label',
  template: `<div
    class="sky-field-label sky-definition-list-label"
    [ngStyle]="{
      'width': (service.labelWidth | async) || ''
    }"
>
  <ng-content></ng-content>
</div>
`,
  styles: [`:host {
  flex: 0 0 90px;
}

.sky-definition-list-label {
  margin-right: 10px;
  word-wrap: break-word;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDefinitionListService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
